import Angular from "angular";
import Controller from "./bookings.controller";
import Template from "./bookings.html";
import Settings from "../../providers/settings.provider";
import Bookings from "../../services/bookings.service";
import Resources from "../../services/resources.service";
import WeekDateSelection from "../../components/week-date-selection/week-date-selection";
import BookingStateIcon from "../../components/bookinst-state-icon/booking-state-icon";
import BookingItem from "../../components/booking-item/booking-item";
import Search from "../../components/search/search";
import DayCalendar from "../../components/calendar/day-calendar";
import WeekCalendar from "../../components/calendar/week-calendar";
import MonthCalendar from "../../components/calendar/month-calendar";
import BookingDetails from "../../components/booking-details/booking-details";
import SplitView from "../../../core/components/split-view/split-view";
import BookingList from "./booking-list";

export const BookingsView = {
    template: Template,
    controller: Controller,
    controllerAs: '$ctrl'
};

export default Angular.module('view.bookings', [
    Settings.name,
    Bookings.name,
    Resources.name,
    WeekDateSelection.name,
    BookingStateIcon.name,
    BookingItem.name,
    Search.name,
    DayCalendar.name,
    WeekCalendar.name,
    MonthCalendar.name,
    BookingDetails.name,
    SplitView.name,
    BookingList.name
]);



// WEBPACK FOOTER //
// ./src/modules/main/views/bookings/bookings.js